import React from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';
import { ProductBannerHeader } from '../ProductHtmlBanner/ProductBannerHeader';
import { styles } from './ScrollTarget.css';

export interface ScrollTargetProps {
  id: string;
  headerOffset?: number;
  heading?: string;
  showAs: 'hide' | 'h2' | 'h3' | 'h4';
  theme?: ContentThemePalette;
}

export const ScrollTarget = ({ id, headerOffset = 50, heading, showAs, theme }: ScrollTargetProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const offset = isDesktop ? headerOffset : 0;
  return (
    <div
      id={id}
      style={showAs === 'hide' ? { position: 'relative', top: -offset } : undefined}
      className={styles.scrollTargetContainer}
    >
      {heading && showAs !== 'hide' ? (
        theme ? (
          <ProductBannerHeader heading={heading} theme={theme} displayAs={showAs} />
        ) : (
          React.createElement(showAs, null, heading)
        )
      ) : null}
    </div>
  );
};
